import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { renderHTML } from '@agility/nextjs';
import Link from 'next/link';
import { List, ListItemButton, ListItemIcon } from '@mui/material';
import { KitGridContainer, KitGridItem } from 'components/common/cms-kit';
import {
  getIcon,
  getColorByAgilityName,
} from '../../services/agilityTranslations';
import ArticleIcon from '@mui/icons-material/Article';

const VideoWithBullets = ({ module }) => {
  const { fields } = module;

  const [videoSelected, setVideoSelected] = useState(null);

  const showDocumentLink = (url, iconColor) => {
    return (
      <ListItemIcon>
        <Link href={url.href} target={url.target} rel="noopener noreferrer">
          <ListText style={{ color: iconColor }}>
            <ArticleIcon /> {url.text}
          </ListText>
          {/* <div title={url.text}>
            <ArticleIcon style={{ width: '20px', color: iconColor }} />
          </div> */}
        </Link>
      </ListItemIcon>
    );
  };

  useEffect(() => {
    if (!videoSelected) {
      if (fields && fields.linkList && fields.linkList.length > 0) {
        setVideoSelected(fields.linkList[0]);
      }
    }
  }, [fields]);

  const [_textAlign, _setTextAlign] = useState('right');

  return (
    <React.Fragment>
      <MobileContainer
        style={{
          backgroundColor: getColorByAgilityName(fields.backgroundColor),
        }}
      >
        <MobileVideoContainer>
          {videoSelected &&
            videoSelected.fields &&
            videoSelected.fields.webinarEmbed && (
              <EmbedContainer
                $videoSelected={!!videoSelected}
                className="prose max-w-full mx-auto"
                dangerouslySetInnerHTML={renderHTML(
                  videoSelected.fields.webinarEmbed,
                )}
              />
            )}
          <DocumentContainer>
            <DocumentLink>
              {videoSelected &&
                videoSelected.fields &&
                videoSelected.fields.documentUrl &&
                showDocumentLink(
                  videoSelected.fields.documentUrl,
                  fields.textColor,
                )}
            </DocumentLink>
          </DocumentContainer>
        </MobileVideoContainer>
        <ListContainer
          $textAlign={fields.textAlign}
          $videoSelected={!!videoSelected}
        >
          <ContentContainer>
            <ResourceDescription
              style={{
                color: fields.textColor,
                margin: 0,
                padding: '-20px 10px',
              }}
            >
              <List>
                {fields.linkList &&
                  fields.linkList.length > 0 &&
                  fields.linkList
                    .sort((a, b) => {
                      if (
                        parseInt(a.fields.sortOrder, 10) >
                        parseInt(b.fields.sortOrder, 10)
                      )
                        return 1;
                      if (
                        parseInt(a.fields.sortOrder, 10) <
                        parseInt(b.fields.sortOrder, 10)
                      )
                        return -1;
                      return 0;
                    })
                    .map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <ListItemButton
                            style={{ width: '100%' }}
                            onClick={(_e) => setVideoSelected(item)}
                          >
                            <KitGridContainer
                              direction="row"
                              style={{ width: '100%' }}
                            >
                              <KitGridItem
                                xs={2}
                                sm={1}
                                align="left"
                                style={{ width: '100%', marginTop: 3 }}
                              >
                                <ListItemIcon>
                                  {getIcon(
                                    fields.iconName,
                                    fields.iconColor,
                                    '1.10rem',
                                  )}
                                </ListItemIcon>
                              </KitGridItem>
                              <KitGridItem
                                xs={10}
                                sm={11}
                                align="left"
                                style={{ width: '100%' }}
                              >
                                <ListText>
                                  {item.fields.webinarUrl.text}
                                </ListText>
                              </KitGridItem>
                            </KitGridContainer>
                          </ListItemButton>
                          <ListSeparator />
                        </React.Fragment>
                      );
                    })}
              </List>
            </ResourceDescription>
          </ContentContainer>
        </ListContainer>
      </MobileContainer>
      <Container
        style={{
          backgroundColor: getColorByAgilityName(fields.backgroundColor),
        }}
      >
        <ListContainer
          $textAlign={fields.textAlign}
          $videoSelected={!!videoSelected}
        >
          <VideoContainer>
            {videoSelected &&
              videoSelected.fields &&
              videoSelected.fields.webinarEmbed && (
                <EmbedContainer
                  $videoSelected={!!videoSelected}
                  className="prose max-w-full mx-auto"
                  dangerouslySetInnerHTML={renderHTML(
                    videoSelected.fields.webinarEmbed,
                  )}
                />
              )}
            <DocumentContainer>
              <DocumentLink>
                {videoSelected &&
                  videoSelected.fields &&
                  videoSelected.fields.documentUrl &&
                  showDocumentLink(
                    videoSelected.fields.documentUrl,
                    fields.textColor,
                  )}
              </DocumentLink>
            </DocumentContainer>
          </VideoContainer>
          <ContentContainer>
            <ResourceDescription
              style={{
                color: fields.textColor,
                margin: 0,
                padding: '-20px 10px',
              }}
            >
              <List>
                {fields.linkList &&
                  fields.linkList.length > 0 &&
                  fields.linkList
                    .sort((a, b) => {
                      if (
                        parseInt(a.fields.sortOrder, 10) >
                        parseInt(b.fields.sortOrder, 10)
                      )
                        return 1;
                      if (
                        parseInt(a.fields.sortOrder, 10) <
                        parseInt(b.fields.sortOrder, 10)
                      )
                        return -1;
                      return 0;
                    })
                    .map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <ListItemButton
                            style={{ width: '100%' }}
                            align="left"
                            onClick={(_e) => setVideoSelected(item)}
                          >
                            <ListItemIcon>
                              {getIcon(
                                fields.iconName,
                                fields.iconColor,
                                '1.10rem',
                              )}
                            </ListItemIcon>
                            <ListText>{item.fields.webinarUrl.text}</ListText>
                          </ListItemButton>
                          <ListSeparator />
                        </React.Fragment>
                      );
                    })}
              </List>
            </ResourceDescription>
          </ContentContainer>
        </ListContainer>
      </Container>
    </React.Fragment>
  );
};
VideoWithBullets.getCustomInitialProps = async function ({
  agility,
  languageCode,
  _channelName,
}) {
  const api = agility;
  let contentItem = null;
  try {
    let list = await api.getContentList({
      referenceName: 'videoWithBullets',
      locale: languageCode,
      expandAllContentLinks: true,
      take: 1,
    });
    if (list && list.items && list.items.length > 0) {
      contentItem = list;
    } else {
      return null;
    }
  } catch (error) {
    if (console)
      console.error('Could not load Video with Bullets video List.', error);
    return null;
  }

  return {
    fields: contentItem,
  };
};
export default VideoWithBullets;
const _ResourceImg = styled('img')(({ theme: _theme }) => ({
  borderTopLeftRadius: '6px',
  borderTopRightRadius: '6px',
  display: 'block',
  minHeight: '75%',
}));

const _ResourceIcon = styled('div')(({ theme }) => ({
  maxWidth: '80px',
  [theme.breakpoints.up('md')]: {
    padding: '5px 40px 10px 40px',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const _ResourceTitle = styled('div')(({ theme: _theme }) => ({
  margin: '-10px 10px',
}));

const ResourceDescription = styled('div')(({ theme }) => ({
  fontWeight: 300,
  margin: '5px 10px 15px 0',
  fontSize: '0.85rem',
  lineHeight: '0.95rem',
  [theme.breakpoints.up('md')]: {
    padding: '0 25px 0 10px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '0 5px',
  },
}));

const ListText = styled('div')(({ theme: _theme }) => ({
  fontWeight: 500,
  fontSize: '0.95rem',
  lineHeight: '1.10rem',
}));

const MobileContainer = styled('div')({
  display: 'flex',
  flexFlow: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  '@media screen and (max-width: 899px)': {
    maxWidth: '100%',
  },
  '@media screen and (min-width: 900px)': {
    display: 'none',
  },
});

const Container = styled('div')({
  display: 'flex',
  flexFlow: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  '@media screen and (max-width: 899px)': {
    display: 'none',
  },
  '@media screen and (min-width: 900px)': {
    maxWidth: '100%',
  },
});

const VideoContainer = styled('div')({
  flexGrow: 0,
  flexShrink: 1,
  margin: '35px 0',
  '& .video': {
    aspectRatio: '16 / 9',
    width: '100%',
  },
  '@media screen and (max-width: 899px)': {
    display: 'none',
  },
  '@media screen and (min-width: 900px)': {
    maxWidth: '100%',
  },
});

const MobileVideoContainer = styled('div')({
  flexGrow: 0,
  flexShrink: 1,
  '& .video': {
    aspectRatio: '16 / 9',
    width: '100%',
  },
  '@media screen and (max-width: 899px)': {
    maxWidth: '100%',
  },
  '@media screen and (min-width: 900px)': {
    display: 'none',
  },
});

const EmbedContainer = styled('div')(({ $videoSelected }) => ({
  '@media screen and (max-width: 899px)': {
    width: $videoSelected ? '450px' : 'auto',
    height: $videoSelected ? '300px' : 'auto',
    display: $videoSelected ? 'block' : 'none',
  },
  '@media screen and (min-width: 900px)': {
    width: $videoSelected ? '450px' : 'auto',
    height: $videoSelected ? '300px' : 'auto',
    display: $videoSelected ? 'block' : 'none',
  },
}));

const _Title = styled('div')(({ theme, $titleColor }) => ({
  fontWeight: 600,
  margin: '40px 5px',
  display: 'flex',
  justifyContent: 'center',
  textTransform: 'uppercase',
  '@media screen and (max-width: 899px)': {
    color: $titleColor,
    fontSize: '1.75rem',
    lineHeight: '1.95rem',
    padding: '0 25px',
  },
  '@media screen and (min-width: 900px)': {
    color: $titleColor,
    fontSize: '2.25rem',
    lineHeight: '2.5rem',
  },
}));

const ContentContainer = styled('div')({
  flexGrow: 1,
  flexShrink: 0,
  flex: 1,
  verticalAlign: 'top',
  '@media screen and (max-width: 899px)': {
    margin: '10px 0',
    padding: '0 20px 0 20px',
    maxWidth: '100%',
  },
  '@media screen and (min-width: 900px)': {
    margin: '35px 0',
    padding: '0 10px',
    maxWidth: '450px',
  },
});

const ListContainer = styled('div')(({ $textAlign, $videoSelected }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flexStart',
  position: 'relative',
  '@media screen and (max-width: 899px)': {
    width: '100%',
    flexDirection: 'column',
  },
  '@media screen and (min-width: 900px)': {
    width: '70%',
    flexDirection: $textAlign === 'left' && $videoSelected ? 'row-reverse' : 'row',
  },
}));

const DocumentContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media screen and (max-width: 899px)': {
    margin: '10px 10px 0 10px',
  },
});

const _ButtonContainer = styled('div')({
  margin: '40px 5px',
  '@media screen and (max-width: 899px)': {
    padding: '0 25px',
  },
});

const ListSeparator = styled('div')({
  margin: '1.5% 0 1.5% 18px',
  width: '95%',
  border: '0.75px dashed #808080',
  '&:last-child': {
    border: '0px',
  },
});

const _HandoutText = styled('div')(({ theme: _theme }) => ({
  fontWeight: 300,
  fontSize: '0.90rem',
  lineHeight: '1.00rem',
}));

const DocumentLink = styled('div')(({ theme: _theme }) => ({
  justifyContent: 'center',
}));

const _Description = styled('div')(({ theme }) => ({
  fontWeight: 300,
  margin: '5px 10px 15px 0',
  fontSize: '0.85rem',
  lineHeight: '0.95rem',
  [theme.breakpoints.up('md')]: {
    padding: '0 25px 0 10px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '0 25px',
  },
}));

// const ListIcon = styled('ListItemIcon')(({ theme }) => ({
//   [theme.breakpoints.up('md')]: {
//     width: '45px',
//   },
//   [theme.breakpoints.down('md')]: {
//     width: '55px',
//   },
// }));